<template>
  <div class="flex flex-col w-full md:w-[536px] h-full -mt-[28px] md:mt-0">
    <div
      class="flex cursor-pointer w-[90%] self-start"
      qa-tag="nav-all-services-back"
      @click="$emit('hide', false)"
    >
      <img
        src="/content-static/navigation-menu/chevron-left.svg"
        alt="chevron left"
        class="fixed-size"
        loading="lazy"
      />
      <span class="ml-ds-sm font-bold">All Services</span>
    </div>
    <div class="overflow-y-auto flex-1 mt-ds-ml">
      <div class="grid gap-ds-lg grid-cols-1 md:grid-cols-2">
        <div :class="$style.serviceSection">
          <a
            href="/removals"
            qa-tag="nav-all-services-removals"
            @click="$emit('track', 'all-services', 'removals-group')"
          >
            Removals &amp; storage
          </a>
          <NavMenuItem
            size="s"
            url="/removals/home-removals"
            qa-tag="nav-all-services-home"
            @click="$emit('track', 'all-services', 'removals')"
          >
            Home removals
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/removals/international-removals"
            qa-tag="nav-all-services-international"
            @click="$emit('track', 'all-services', 'international')"
          >
            International removals
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/removals/office-removals"
            qa-tag="nav-all-services-office"
            @click="$emit('track', 'all-services', 'office')"
          >
            Office removals
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/removals/student-movers"
            qa-tag="nav-all-services-student"
            @click="$emit('track', 'all-services', 'student')"
          >
            Student removals
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/storage"
            qa-tag="nav-all-services-storage"
            @click="$emit('track', 'all-services', 'storage')"
          >
            Storage services
          </NavMenuItem>
        </div>
        <div :class="$style.serviceSection">
          <a
            href="/man-and-van"
            qa-tag="nav-all-services-man-and-van"
            @click="$emit('track', 'all-services', 'man-and-van-group')"
          >
            Man &amp; Van services
          </a>
          <NavMenuItem
            size="s"
            url="/courier-services/furniture-couriers"
            qa-tag="nav-all-services-furniture"
            @click="$emit('track', 'all-services', 'furniture')"
          >
            Furniture &amp; appliance delivery
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/removals/piano-movers"
            qa-tag="nav-all-services-piano"
            @click="$emit('track', 'all-services', 'piano')"
          >
            Piano delivery
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/instant-prices/furniture/listing-items"
            qa-tag="nav-all-services-parcel"
            @click="$emit('track', 'all-services', 'parcel')"
          >
            Parcel delivery
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/instant-prices-ebay"
            qa-tag="nav-all-services-ebay"
            @click="$emit('track', 'all-services', 'ebay')"
          >
            eBay delivery
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/courier-services/gumtree-couriers"
            qa-tag="nav-all-services-gumtree"
            @click="$emit('track', 'all-services', 'gumtree')"
          >
            Gumtree delivery
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/courier-services/heavy-large-item-couriers"
            qa-tag="nav-all-services-heavy-large-item"
            @click="$emit('track', 'all-services', 'heavy-large-item')"
          >
            Heavy &amp; large item delivery
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/instant-prices/furniture/listing-items"
            qa-tag="nav-all-services-specialist"
            @click="$emit('track', 'all-services', 'specialist')"
          >
            Specialist &amp; antiques delivery
          </NavMenuItem>
        </div>
        <div :class="$style.serviceSection">
          <a
            href="/vehicle-delivery"
            qa-tag="nav-all-services-vehicle"
            @click="$emit('track', 'all-services', 'vehicle-group')"
          >
            Vehicle delivery
          </a>
          <NavMenuItem
            size="s"
            url="/vehicle-delivery/car-delivery"
            qa-tag="nav-all-services-car"
            @click="$emit('track', 'all-services', 'car')"
          >
            Car transport
          </NavMenuItem>
          <NavMenuItem
            size="s"
            url="/vehicle-delivery/motorcycle-delivery"
            qa-tag="nav-all-services-motorcycle"
            @click="$emit('track', 'all-services', 'motorcycle')"
          >
            Motorcycle transport
          </NavMenuItem>
        </div>
      </div>
    </div>
    <div class="md:hidden w-full -mb-ds-sm border-t border-t-black10">
      <div class="w-full flex justify-center items-center h-full mt-ds-md">
        <img
          class="w-ds-ml fixed-size"
          src="/content-static/navigation-menu/chevron-down-2.svg"
          alt="chevron down"
          loading="lazy"
        />
      </div>
      <a
        href="/categories"
        class="absolute bottom-[26px] translate-y-2/4 flex right-ds-lg no-underline text-sm text-base-dark hover:no-underline hover:text-base-dark"
        qa-tag="nav-all-services-view-all"
        @click="$emit('track', 'all-services', 'view-all')"
      >
        <span class="opacity-50">View all</span>
        <img
          class="ml-ds-xxs fixed-size"
          src="/content-static/navigation-menu/chevron-right.svg"
          alt="chevron right"
          loading="lazy"
        />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "NavAllServicesEn"
})
</script>

<style lang="css" module>
.serviceSection {
  @apply flex flex-col gap-ds-sm;

  > a:first-child {
    @apply border-t-2 pt-ds-sm mb-ds-xxs text-black opacity-50 no-underline hover:no-underline hover:opacity-70;
  }

  > a:first-child:hover ~ a {
    @apply opacity-40;
  }
}
</style>
